module.exports = __webpack_public_path__ + "media/szamar_k.5dc31a2f.mp3";